// src/components/ui/Loader.jsx
import React from 'react';
import { Brain } from 'lucide-react';
import { SafeIcon } from '../../contexts/nobishiro-dashboard/SVGErrorBoundary';

const Loader = ({ message = "読み込み中...", subMessage = "" }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center">
      <div className="relative mb-8">
        <div className="animate-spin rounded-full h-20 w-20 border-t-4 border-b-4 border-blue-600"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
          <SafeIcon IconComponent={Brain} className="h-10 w-10 text-blue-500" />
        </div>
      </div>
      <div className="text-center">
        <p className="text-2xl text-gray-700 font-semibold tracking-wider mb-2">{message}</p>
        {subMessage && <p className="text-gray-500">{subMessage}</p>}
      </div>
    </div>
  );
};

export default Loader;